<template>
  <div>
    <BundleComponentDetails
      v-if="items.length > 0"
      :items="items"
    />
    <div
      v-else
      class="flex justify-center items-center h-[100px]"
    >
      <b-spinner
        v-if="isLoading"
        variant="primary"
        size="sm"
        class="mx-auto"
      />
      <div
        v-else-if="isError"
        class="flex items-center justify-center gap-[10px]"
      >
        List produk penyusun bundle varian gagal dimuat.
        <b-button
          variant="primary"
          size="sm"
          @click="fetchDetailBundleVarian"
        >
          Coba lagi
        </b-button>
      </div>
      <div
        v-else
        class="flex items-center justify-center gap-[10px]"
      >
        List produk penyusun bundle varian tidak ditemukan.
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Component untuk menampilkan detail bundle varian di page Gudangku > Gudang Mitra Kompack > Detail Gudangku.
 * Component gunakan BundleComponentDetails untuk menampilkan detail produk penyusun bundle varian.
 * @param {String} productId - ID produk
 */
import BundleComponentDetails from './BundleComponentDetails.vue'

export default {
  name: 'BundleVarianInWarehouseDetail',
  components: {
    BundleComponentDetails,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      isLoading: true,
      isError: false,
    }
  },
  methods: {
    /**
     * Method untuk fetch detail bundle varian
     */
    async fetchDetailBundleVarian() {
      if (this.items.length > 0) return
      this.isLoading = true
      try {
        const { data: { data } } = await this.$http_new.get(`/komship/api/v1/product-variant-bundles/${this.productId}/list`)
        this.items = data
      } catch (error) {
        console.error('[error fetchDetailBundleVarian]', error)
        this.isError = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
